import { Component, OnInit, ChangeDetectorRef, ViewChild, Input } from "@angular/core";
import { TranslateService } from "ng2-translate";
import { Router, ActivatedRoute } from "@angular/router";
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from "rxjs";
import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { AngularFirestore } from "angularfire2/firestore";
import { MetaService } from 'ng2-meta';
import { ScrollService } from '../_services/scroll.service';



@Component({
  selector: "app-product-profile",
  templateUrl: "./product-profile.component.html",
  styleUrls: ["./product-profile.component.css"]
})
export class ProductProfileComponent implements OnInit {
  sub: any;
  uniqueName;
  private subscription: Subscription = new Subscription();
  @ViewChild('tabset') tabset: NgbTabset;
  @Input() username;
  productName: string;
  product: any;
  visible: any;
  user: any;
  productId: any;
  tooltip = "banka şube adının nasıl belirtileceği, kullanıcıdan bu bilginin nasıl alınacağı değerlendirilecek. şube hizmet kalitesini mutlaka ölçebilmeliyiz";
  mobileQuery: any;
  name: string;
  private subs = new Subscription();
  private _mobileQueryListener: () => void;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    private metaService: MetaService,
    private media: MediaMatcher,
    private scrollService: ScrollService,
    private cd: ChangeDetectorRef,
    private afs: AngularFirestore
  ) {
    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.subscription.add(this.route.url.subscribe(data => {
      const url = decodeURIComponent(this.router.url);
      if (url.indexOf("#") != -1) {

        this.productName = this.route.snapshot.params["uniqueName"].split("#")[0];
        this.uniqueName = (url.split("#")[0] || url.split("#")[0].split("/")[2]) + "/hashtags/" + url.split("#")[1];

      } else {



        this.productName = this.uniqueName = this.route.snapshot.params["uniqueName"];




      }
      this.afs.collection('products').ref.where('uniqueName', '==', this.productName).onSnapshot(snap => {
        snap.docs.map(products => {
          this.productId = products.id;
          this.product = products.data();
          this.metaService.setTitle(this.product.name + ' ' + '- Kullanıcı Yorumları, Müşteri Şikayet, Görüş ve Önerileri | bigadvice.com');
          this.metaService.setTag('description', this.product.name + ' ' +
            'ile ilgili müşteri şikayet, görüş ve öneri paylaşımlarını okuyabilir, burada sen de deneyimlerini özgürce paylaşabilirsin');
        })

      })

    }));

  }

  tabSelect() {
    this.subscription.add(this.route.queryParamMap.subscribe(params => {
      let queryString = this.route.snapshot.queryParams['tag'];
      if (queryString == 'followers') {
        this.tabset.select("followers");
      } else if (queryString == 'current') {
        this.tabset.select("current");
      }
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subs.unsubscribe();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngOnInit() {
    this.subs = this.scrollService.isScroll.subscribe(a => {
      if (document.querySelector(".perfect-scrollbar").scrollTop > 620) {
        this.visible = true;

      }
      else {
        this.visible = false;

      }
    })
    this.tabSelect();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/product-profile/product-profile.component.ts